/**
 * Reverses Base Acres commodity transforms on import (`transformBaseAcresCommodity` in ImportService)
 * so spreadsheet export matches uploaded template wording (CCC-866 commodity column style).
 *
 * `ProducerFarmBaseAcres.type_name` is Rice grain type only (`Long Grain` | `Medium Grain` | `Short Grain`),
 * matching rg-chat-toolkit `Transform_BaseAcresFSA866Form.schema.json`: non-null only when `commodity_name`
 * is `Rice`.
 */

import { BASE_ACRES_COMMODITY_NAMES_WITH_TYPE, formatBaseAcresRiceExportCommodityLabel } from "./helpers";

const normalize = (str) => (str || "").toString().trim().toLowerCase();

function commodityUsesStoredTypeName(commodity_name) {
  if (commodity_name === null || commodity_name === undefined) return false;
  const raw = String(commodity_name);
  return BASE_ACRES_COMMODITY_NAMES_WITH_TYPE.some((n) => n === raw || normalize(n) === normalize(raw));
}

/**
 * @param {object} row Crop / base-acre row shaped like Memory / DB payloads
 * @returns {object} Shallow clone with spreadsheet-oriented commodity/type fields
 */
export function reverseBaseAcresImportTransformsForExport(row) {
  if (!row || typeof row !== "object") {
    return row;
  }

  const out = { ...row };
  const c = out.commodity_name;

  if (c === "Cotton") {
    out.commodity_name = "Seed Cotton";
    return out;
  }

  if (c === "Sunflower Seed") {
    out.commodity_name = "Sunflowers";
    return out;
  }

  /** Rice (+ grain type): canonical DB fields → CCC-866 style e.g. `RICE-LONG GRAIN` (see `formatBaseAcresRiceExportCommodityLabel`). */
  if (commodityUsesStoredTypeName(c)) {
    out.commodity_name = formatBaseAcresRiceExportCommodityLabel(out.type_name);
    out.type_name = null;
    return out;
  }

  return out;
}
